module.exports = __webpack_public_path__ + "img/page16.4d64ccf0.jpg";